"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GLWBPageFour;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _GuaranteedLifetimeWithdrawalBenefitWizardFormControls = require("./GuaranteedLifetimeWithdrawalBenefitWizardFormControls");
var _ResultsTable = require("./ResultsTable");
var _GuaranteedLifetimeWithdrawalBenefitWizardCalc = require("./GuaranteedLifetimeWithdrawalBenefitWizardCalc.config");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function GLWBPageFour(_ref) {
  var {
    apiData,
    fetchDataScienceResults
  } = _ref;
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();

  // If the user has landed on the page for the first time, we don't want to call the API again until the user has changed their net market growth option
  var isFirstRender = (0, _react.useRef)(true);
  (0, _react.useEffect)(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    fetchDataScienceResults(values);
  }, [values.net_market_growth_rate]);

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    document.getElementById(_GuaranteedLifetimeWithdrawalBenefitWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else */
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-8 glwb-alert-style"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col dropdown-pg4"
  }, /*#__PURE__*/_react.default.createElement(_GuaranteedLifetimeWithdrawalBenefitWizardFormControls.MarketGrowthRate, {
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue,
    values: values
  }))), /*#__PURE__*/_react.default.createElement(_ResultsTable.ResultsTable, {
    apiResults: apiData === null || apiData === void 0 ? void 0 : apiData.data
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null)));
}